// ImagesContainer.js
import React from "react";
import CompareSlider from "./CompareSlider";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import Masonry from "react-masonry-css";

function ImagesContainer({ baseURL, filteredImages }) {
  return (
    <div className="slider-container slide-in">
      <LazyLoadComponent>
        <Masonry
          breakpointCols={{ default: 3, 1100: 2, 700: 1 }}
          className="masonry-grid"
          columnClassName="masonry-grid_column"
        >
          {filteredImages.map((image, index) => (
            <CompareSlider
              key={index}
              beforeImage={`${baseURL}/web/sites/default/files/portfolio/${image.category}/${image.name}_before.webp`}
              afterImage={`${baseURL}/web/sites/default/files/portfolio/${image.category}/${image.name}_after.webp`}
              className="slide-in" // Add slide-in animation class
            />
          ))}
        </Masonry>
      </LazyLoadComponent>
    </div>
  );
}

export default ImagesContainer;
